import { useEffect } from "react";
import { useSelector } from "react-redux";

import { initializeChurnZeroContact } from "services/utility/churnZero";
import { isBetaEnvironment } from "services/utility/misc";

export function useChurnZero() {
  const { isLoggedIn } = useSelector((state) => state.authentication);
  const companyId = useSelector(
    (state) => state.userCompanySettings.company.id
  );
  const userEmail = useSelector(
    (state) => state.userCompanySettings.user.email
  );

  useEffect(() => {
    if (isLoggedIn === "yes" && companyId && userEmail && isBetaEnvironment) {
      // due to ChurnZero licensing, we are limiting tracking to any
      // tenant with companyID greater than 75103, accounts that 
      // subscribed on or after Oct 1st, 2025, or later.
      if (companyId > 75103) {
        const accountExternalId = `SOS_${companyId}`;
        initializeChurnZeroContact(accountExternalId, userEmail);
      }
    }
  }, [isLoggedIn, companyId, userEmail]);
}
